var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _g2, _path16, _g3, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g4, _path27, _g5, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoleImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 186,
    viewBox: "0 0 320 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_83550)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.304 53.4917C155.285 53.4917 160.262 54.3847 164.727 56.1706L238.708 85.7578C247.629 89.3296 253.132 95.926 253.132 103.066V162.248C253.132 169.388 247.629 175.984 238.708 179.556L164.727 209.143C160.262 210.929 155.285 211.822 150.304 211.822C145.322 211.822 140.345 210.929 135.88 209.143L61.8994 179.556C52.9778 175.984 47.4756 169.388 47.4756 162.248V103.066C47.4756 95.926 52.9778 89.3296 61.8994 85.7578L135.88 56.1706C140.345 54.3847 145.322 53.4917 150.304 53.4917Z",
    fill: "url(#paint0_radial_35_83550)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.703 77.3631H207.855V75.717H237.703C242.037 75.717 245.567 72.1781 245.567 67.8244V45.1217C245.567 39.8627 249.831 35.583 255.071 35.583H332.089V37.229H255.071C250.737 37.229 247.207 40.768 247.207 45.1217V67.8244C247.207 73.0834 242.943 77.3631 237.703 77.3631Z",
    fill: "url(#paint1_linear_35_83550)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M365.115 124.703H276.432C271.29 124.703 267.108 120.505 267.108 115.345V105.922C267.108 101.671 263.66 98.21 259.425 98.21H206.387V96.564H259.425C264.566 96.564 268.748 100.761 268.748 105.922V115.345C268.748 119.596 272.197 123.057 276.432 123.057H365.115V124.703Z",
    fill: "url(#paint2_linear_35_83550)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M331.688 87.6958H207.855V89.3418H331.688V87.6958Z",
    fill: "url(#paint3_linear_35_83550)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M331.688 67.0962H207.855V68.7422H331.688V67.0962Z",
    fill: "url(#paint4_linear_35_83550)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0258 77.6427H-45V75.9967H40.0258C43.683 75.9967 46.6555 73.0091 46.6555 69.3426V61.738C46.6555 57.1621 50.366 53.438 54.9252 53.438H86.9134V55.084H54.9252C51.268 55.084 48.2955 58.0715 48.2955 61.738V69.3426C48.2955 73.9186 44.585 77.6427 40.0258 77.6427Z",
    fill: "url(#paint5_linear_35_83550)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87 61H-45V63H87V61Z",
    fill: "url(#paint6_linear_35_83550)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87 89H19.4498C14.7462 89 10.9182 85.2958 10.9182 80.7444V47.2556C10.9182 43.6046 7.84737 40.6372 4.0786 40.6372H-45V39H4.07437C8.77793 39 12.6059 42.7042 12.6059 47.2556V80.7444C12.6059 84.3954 15.6768 87.3628 19.4455 87.3628H86.9958V89H87Z",
    fill: "url(#paint7_linear_35_83550)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-17.4972 115.271H-45V113.625H-17.4972C-13.2086 113.625 -9.7195 110.123 -9.7195 105.818C-9.7195 100.605 -5.4965 96.3662 -0.3018 96.3662H86.4747V98.0122H-0.3018C-4.5904 98.0122 -8.0795 101.514 -8.0795 105.818C-8.0795 111.032 -12.3025 115.271 -17.4972 115.271Z",
    fill: "url(#paint8_linear_35_83550)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M217.375 108.185C217.375 108.222 217.367 108.263 217.363 108.3C217.338 108.555 217.301 108.806 217.256 109.057C217.252 109.09 217.244 109.119 217.236 109.152C217.187 109.407 217.125 109.662 217.055 109.913C217.055 109.921 217.051 109.934 217.047 109.942C216.978 110.189 216.891 110.436 216.801 110.678C216.781 110.728 216.764 110.777 216.744 110.826C216.654 111.061 216.555 111.291 216.445 111.518C216.399 111.608 216.35 111.699 216.305 111.794C216.223 111.954 216.141 112.114 216.047 112.275C215.99 112.374 215.928 112.472 215.867 112.571C215.776 112.719 215.682 112.868 215.584 113.012C215.514 113.114 215.444 113.213 215.37 113.312C215.268 113.452 215.165 113.592 215.059 113.728C214.981 113.826 214.903 113.925 214.821 114.02C214.698 114.168 214.567 114.316 214.436 114.46C214.374 114.526 214.317 114.592 214.255 114.658C214.058 114.867 213.853 115.069 213.64 115.271C213.636 115.271 213.632 115.279 213.628 115.283C213.411 115.485 213.177 115.682 212.943 115.876C212.869 115.933 212.796 115.991 212.722 116.053C212.55 116.188 212.373 116.324 212.193 116.456C212.107 116.518 212.025 116.579 211.939 116.637C211.742 116.773 211.541 116.909 211.336 117.04C211.266 117.085 211.201 117.127 211.135 117.172C210.86 117.341 210.582 117.505 210.29 117.666C210.229 117.699 210.163 117.732 210.098 117.769C209.86 117.896 209.618 118.02 209.372 118.139C209.298 118.172 209.229 118.209 209.155 118.242C208.851 118.382 208.548 118.522 208.232 118.649L161.14 137.945C160.365 138.261 159.565 138.537 158.745 138.768C157.831 139.027 156.831 139.253 155.879 139.401L155.92 149.068C156.872 148.919 157.827 148.714 158.741 148.454C159.561 148.224 160.361 147.948 161.136 147.631L208.228 128.336C208.544 128.208 208.851 128.069 209.151 127.929C209.225 127.896 209.298 127.859 209.368 127.826C209.438 127.793 209.511 127.76 209.577 127.727C209.753 127.641 209.921 127.546 210.094 127.455C210.159 127.422 210.225 127.39 210.286 127.352C210.573 127.192 210.856 127.027 211.131 126.859C211.201 126.818 211.266 126.772 211.332 126.727C211.537 126.595 211.738 126.464 211.935 126.324C212.021 126.262 212.107 126.204 212.189 126.143C212.369 126.011 212.546 125.875 212.718 125.739C212.792 125.682 212.865 125.624 212.939 125.567C213.177 125.373 213.406 125.176 213.624 124.97L213.632 124.962C213.849 124.76 214.05 124.554 214.251 124.349C214.313 124.283 214.374 124.217 214.432 124.151C214.509 124.065 214.595 123.978 214.673 123.892C214.723 123.834 214.768 123.772 214.817 123.715C214.899 123.616 214.977 123.521 215.055 123.423C215.161 123.287 215.268 123.147 215.366 123.007C215.44 122.908 215.51 122.809 215.58 122.707C215.678 122.563 215.772 122.414 215.862 122.266C215.924 122.168 215.985 122.069 216.043 121.97C216.133 121.81 216.219 121.649 216.301 121.489C216.346 121.398 216.399 121.307 216.44 121.213C216.449 121.192 216.461 121.172 216.473 121.151C216.572 120.941 216.658 120.731 216.74 120.522C216.76 120.472 216.777 120.423 216.797 120.373C216.887 120.131 216.974 119.884 217.043 119.633C217.043 119.624 217.047 119.612 217.051 119.604C217.096 119.447 217.138 119.287 217.174 119.127C217.195 119.032 217.215 118.937 217.232 118.843C217.236 118.81 217.244 118.781 217.252 118.748C217.297 118.497 217.334 118.246 217.359 117.991C217.359 117.954 217.367 117.913 217.371 117.876C217.388 117.682 217.4 117.493 217.408 117.295C217.408 117.213 217.408 117.135 217.408 117.053V107.366C217.408 107.641 217.396 107.913 217.371 108.185H217.375Z",
    fill: "url(#paint9_linear_35_83550)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.374 139.652C152.903 139.677 152.431 139.689 151.956 139.689C151.587 139.689 151.218 139.681 150.849 139.665C149.963 139.628 149.086 139.545 148.213 139.414C147.192 139.261 146.183 139.047 145.199 138.772C144.371 138.537 143.559 138.261 142.776 137.94L95.6833 118.645C90.0048 116.316 86.5034 112.016 86.5034 107.357V117.044C86.5034 121.698 90.0048 126.003 95.6833 128.332L142.776 147.627C143.563 147.948 144.371 148.228 145.199 148.458C146.183 148.734 147.192 148.948 148.213 149.1C149.082 149.228 149.963 149.314 150.849 149.351C151.218 149.368 151.587 149.376 151.956 149.376C152.427 149.376 152.903 149.364 153.374 149.339C154.235 149.294 155.092 149.203 155.941 149.068V139.381C155.092 139.512 154.235 139.603 153.374 139.652Z",
    fill: "url(#paint10_linear_35_83550)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.96 37.7803C155.129 37.7803 158.298 38.3605 161.14 39.5251L208.232 58.8205C213.911 61.1496 217.412 65.4498 217.412 70.1081V108.703C217.412 113.357 213.911 117.662 208.232 119.991L161.14 139.286C158.298 140.451 155.129 141.031 151.96 141.031C148.79 141.031 145.621 140.451 142.78 139.286L95.6872 119.991C90.0087 117.662 86.5073 113.361 86.5073 108.703V70.1081C86.5073 65.4539 90.0087 61.1496 95.6872 58.8205L142.78 39.5251C145.621 38.3605 148.79 37.7803 151.96 37.7803Z",
    fill: "url(#paint11_linear_35_83550)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.96 141.335C151.587 141.335 151.214 141.327 150.841 141.31C149.947 141.273 149.049 141.187 148.171 141.059C147.134 140.907 146.105 140.689 145.121 140.409C144.276 140.171 143.452 139.887 142.665 139.566L95.5725 120.27C89.7915 117.9 86.2 113.464 86.2 108.699H86.815C86.815 113.209 90.2589 117.427 95.8062 119.698L142.899 138.994C143.666 139.306 144.469 139.582 145.289 139.813C146.249 140.084 147.253 140.294 148.266 140.446C149.119 140.574 149.996 140.656 150.869 140.693C151.697 140.73 152.534 140.722 153.362 140.677C154.211 140.631 155.064 140.541 155.896 140.409C156.839 140.261 157.77 140.055 158.663 139.804C159.475 139.574 160.271 139.302 161.025 138.994L208.118 119.698C208.429 119.571 208.728 119.435 209.028 119.295L209.245 119.192C209.487 119.073 209.725 118.953 209.963 118.826L210.151 118.727C210.434 118.571 210.713 118.41 210.979 118.242L211.18 118.114C211.381 117.986 211.578 117.855 211.771 117.719C211.857 117.661 211.939 117.6 212.021 117.538C212.197 117.41 212.369 117.279 212.537 117.143L212.603 117.089C212.652 117.048 212.705 117.011 212.755 116.97C212.984 116.781 213.21 116.587 213.427 116.386C213.648 116.18 213.849 115.978 214.042 115.777C214.083 115.731 214.124 115.69 214.165 115.645L214.222 115.583C214.354 115.443 214.477 115.299 214.6 115.155C214.678 115.061 214.755 114.966 214.833 114.867C214.94 114.736 215.038 114.6 215.141 114.46C215.211 114.361 215.28 114.266 215.346 114.168C215.44 114.028 215.53 113.884 215.621 113.74L215.666 113.67C215.711 113.596 215.756 113.526 215.797 113.452C215.887 113.299 215.965 113.139 216.047 112.982L216.1 112.884C216.129 112.83 216.158 112.773 216.186 112.719C216.289 112.501 216.387 112.275 216.477 112.048L216.527 111.921C216.633 111.633 216.711 111.402 216.773 111.188C216.846 110.925 216.904 110.686 216.953 110.423L216.974 110.332C217.015 110.102 217.051 109.855 217.076 109.6L217.088 109.489C217.113 109.209 217.125 108.95 217.125 108.699H217.74C217.74 108.966 217.728 109.246 217.699 109.546L217.687 109.666C217.658 109.937 217.621 110.201 217.576 110.448L217.564 110.505C217.502 110.822 217.441 111.081 217.371 111.328C217.297 111.592 217.215 111.834 217.109 112.118L217.051 112.275C216.957 112.517 216.855 112.756 216.744 112.987C216.715 113.048 216.682 113.114 216.65 113.176L216.6 113.271C216.514 113.435 216.428 113.604 216.338 113.764C216.293 113.843 216.244 113.921 216.195 114.003L216.154 114.073C216.059 114.225 215.965 114.373 215.862 114.526C215.793 114.629 215.719 114.727 215.649 114.83C215.543 114.978 215.436 115.118 215.325 115.258C215.247 115.361 215.165 115.46 215.079 115.559C214.952 115.711 214.821 115.859 214.686 116.007L214.632 116.065C214.587 116.114 214.546 116.159 214.501 116.209C214.28 116.439 214.075 116.645 213.87 116.834C213.653 117.036 213.427 117.233 213.161 117.451C213.107 117.497 213.054 117.538 213.001 117.579L212.935 117.628C212.759 117.768 212.582 117.904 212.398 118.036C212.312 118.097 212.226 118.159 212.14 118.221C211.939 118.361 211.738 118.497 211.529 118.628L211.324 118.76C211.045 118.933 210.758 119.102 210.467 119.262L210.27 119.365C210.028 119.492 209.782 119.62 209.532 119.744L209.311 119.851C209.003 119.995 208.696 120.134 208.372 120.266L161.279 139.562C160.5 139.878 159.684 140.162 158.852 140.397C157.934 140.656 156.978 140.866 156.011 141.018C155.158 141.154 154.285 141.245 153.415 141.294C152.94 141.319 152.456 141.335 151.98 141.335H151.96Z",
    fill: "url(#paint12_linear_35_83550)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.96 40.7676C154.986 40.7676 158.007 41.3108 160.722 42.393L205.654 60.3634C211.07 62.532 214.415 66.5401 214.415 70.8732V106.818C214.415 111.155 211.074 115.159 205.654 117.328L160.722 135.298C158.012 136.385 154.986 136.924 151.96 136.924C148.934 136.924 145.912 136.381 143.198 135.298L98.2663 117.328C92.8502 115.159 89.5046 111.151 89.5046 106.818V70.8732C89.5046 66.536 92.8461 62.532 98.2663 60.3634L143.198 42.393C145.908 41.3066 148.934 40.7676 151.96 40.7676Z",
    fill: "#142F38"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M217.375 89.292C217.375 89.3291 217.367 89.3702 217.363 89.4073C217.338 89.6624 217.302 89.9134 217.256 90.1644C217.252 90.1973 217.244 90.2262 217.236 90.2591C217.187 90.5142 217.125 90.7693 217.056 91.0204C217.056 91.0286 217.051 91.0409 217.047 91.0492C216.978 91.2961 216.892 91.543 216.801 91.7858C216.781 91.8351 216.764 91.8845 216.744 91.9339C216.654 92.1685 216.555 92.3989 216.445 92.6252C216.4 92.7158 216.35 92.8063 216.305 92.9009C216.223 93.0614 216.141 93.2219 216.047 93.3824C215.99 93.4812 215.928 93.5799 215.867 93.6787C215.776 93.8268 215.682 93.975 215.584 94.119C215.514 94.2219 215.444 94.3206 215.37 94.4194C215.268 94.5593 215.165 94.6992 215.059 94.835C214.981 94.9338 214.903 95.0325 214.821 95.1272C214.698 95.2753 214.567 95.4235 214.436 95.5675C214.374 95.6333 214.317 95.6992 214.255 95.765C214.059 95.9749 213.854 96.1765 213.64 96.3781C213.636 96.3781 213.632 96.3864 213.628 96.3905C213.411 96.5921 213.177 96.7896 212.943 96.9831C212.869 97.0407 212.796 97.0983 212.722 97.16C212.55 97.2958 212.373 97.4316 212.193 97.5633C212.107 97.625 212.025 97.6867 211.939 97.7443C211.742 97.8801 211.541 98.0159 211.336 98.1476C211.266 98.1929 211.201 98.234 211.135 98.2793C210.86 98.448 210.582 98.6126 210.291 98.7731C210.229 98.806 210.163 98.8389 210.098 98.876C209.86 99.0035 209.618 99.127 209.372 99.2463C209.298 99.2792 209.229 99.3163 209.155 99.3492C208.852 99.4891 208.548 99.629 208.232 99.7566L161.14 119.052C160.365 119.369 159.565 119.645 158.745 119.875C157.831 120.134 156.818 120.34 155.867 120.488L155.912 130.179C156.863 130.031 157.827 129.821 158.741 129.562C159.561 129.331 160.361 129.056 161.136 128.739L208.228 109.443C208.544 109.316 208.851 109.176 209.151 109.036C209.225 109.003 209.298 108.966 209.368 108.933C209.438 108.9 209.512 108.867 209.577 108.834C209.753 108.748 209.922 108.653 210.094 108.563C210.159 108.53 210.225 108.497 210.286 108.46C210.573 108.299 210.856 108.135 211.131 107.966C211.201 107.925 211.266 107.88 211.332 107.834C211.537 107.703 211.738 107.571 211.935 107.431C212.021 107.369 212.107 107.312 212.189 107.25C212.369 107.118 212.546 106.983 212.718 106.847C212.792 106.789 212.865 106.732 212.939 106.674C213.177 106.481 213.407 106.283 213.624 106.077L213.632 106.069C213.849 105.867 214.05 105.662 214.251 105.456C214.313 105.39 214.374 105.324 214.432 105.258C214.509 105.172 214.596 105.086 214.673 104.999C214.723 104.942 214.768 104.88 214.817 104.822C214.899 104.723 214.977 104.629 215.055 104.53C215.161 104.394 215.268 104.254 215.366 104.114C215.44 104.016 215.51 103.917 215.58 103.814C215.678 103.67 215.772 103.522 215.862 103.374C215.924 103.275 215.985 103.176 216.043 103.077C216.133 102.917 216.219 102.756 216.301 102.596C216.346 102.505 216.4 102.415 216.441 102.32C216.449 102.3 216.461 102.279 216.473 102.259C216.572 102.049 216.658 101.839 216.74 101.629C216.76 101.58 216.777 101.53 216.797 101.481C216.887 101.238 216.974 100.991 217.043 100.74C217.043 100.732 217.047 100.72 217.051 100.711C217.097 100.555 217.138 100.394 217.174 100.234C217.195 100.139 217.215 100.045 217.232 99.95C217.236 99.9171 217.244 99.8883 217.252 99.8554C217.298 99.6043 217.334 99.3533 217.359 99.0982C217.359 99.0612 217.367 99.02 217.371 98.983C217.388 98.7896 217.4 98.6003 217.408 98.4027C217.408 98.3204 217.408 98.2423 217.408 98.16V88.4731C217.408 88.7489 217.396 89.0204 217.371 89.292H217.375Z",
    fill: "url(#paint13_linear_35_83550)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.374 120.764C152.903 120.789 152.431 120.801 151.956 120.801C151.587 120.801 151.218 120.793 150.849 120.776C149.963 120.739 149.086 120.657 148.213 120.525C147.192 120.373 146.183 120.159 145.199 119.883C144.371 119.649 143.559 119.373 142.776 119.052L95.6833 99.7568C90.0048 97.4277 86.5034 93.1275 86.5034 88.4692V98.156C86.5034 102.81 90.0048 107.114 95.6833 109.444L142.776 128.739C143.563 129.06 144.371 129.34 145.199 129.57C146.183 129.846 147.192 130.06 148.213 130.212C149.082 130.34 149.963 130.426 150.849 130.463C151.218 130.48 151.587 130.488 151.956 130.488C152.427 130.488 152.903 130.476 153.374 130.451C154.235 130.406 155.092 130.315 155.941 130.179V120.493C155.092 120.624 154.235 120.715 153.374 120.764Z",
    fill: "url(#paint14_linear_35_83550)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.96 18.8921C155.129 18.8921 158.298 19.4723 161.14 20.6369L208.232 39.9323C213.911 42.2614 217.412 46.5616 217.412 51.2199V89.8149C217.412 94.469 213.911 98.7733 208.232 101.102L161.14 120.398C158.298 121.562 155.129 122.143 151.96 122.143C148.79 122.143 145.621 121.562 142.78 120.398L95.6872 101.102C90.0087 98.7733 86.5073 94.4731 86.5073 89.8149V51.2199C86.5073 46.5658 90.0087 42.2614 95.6872 39.9323L142.78 20.6369C145.621 19.4723 148.79 18.8921 151.96 18.8921Z",
    fill: "url(#paint15_linear_35_83550)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.96 122.447C151.587 122.447 151.214 122.439 150.841 122.422C149.947 122.385 149.049 122.299 148.171 122.171C147.134 122.019 146.105 121.801 145.121 121.521C144.276 121.282 143.448 120.998 142.665 120.677L95.5725 101.382C89.7915 99.0118 86.2 94.5758 86.2 89.8105H86.815C86.815 94.3206 90.2589 98.5386 95.8062 100.81L142.899 120.106C143.661 120.418 144.469 120.694 145.289 120.924C146.253 121.196 147.253 121.406 148.266 121.558C149.123 121.686 150 121.768 150.869 121.805C151.702 121.842 152.538 121.834 153.362 121.789C154.211 121.743 155.064 121.653 155.896 121.521C156.839 121.373 157.77 121.167 158.663 120.916C159.475 120.686 160.266 120.414 161.025 120.106L208.118 100.81C208.429 100.682 208.733 100.547 209.028 100.407L209.245 100.304C209.487 100.185 209.725 100.065 209.963 99.9377L210.151 99.8389C210.434 99.6825 210.713 99.5221 210.979 99.3533L211.18 99.2258C211.381 99.0982 211.578 98.9665 211.771 98.8307C211.857 98.7731 211.939 98.7114 212.021 98.6497C212.197 98.5221 212.369 98.3904 212.537 98.2546L212.755 98.0818C212.984 97.8925 213.21 97.6991 213.427 97.5016C213.648 97.2958 213.849 97.0942 214.042 96.8925L214.218 96.6991C214.35 96.5592 214.473 96.4152 214.596 96.2712C214.673 96.1765 214.751 96.0819 214.829 95.9831C214.936 95.8473 215.034 95.7156 215.137 95.5757C215.206 95.4811 215.276 95.3823 215.342 95.2836C215.436 95.1436 215.526 94.9996 215.616 94.8556L215.662 94.7815C215.707 94.7116 215.748 94.6375 215.793 94.5675C215.883 94.4112 215.961 94.2548 216.043 94.0984L216.096 93.9997C216.125 93.9462 216.154 93.8886 216.182 93.8351C216.285 93.617 216.383 93.3906 216.473 93.1643L216.527 93.0244C216.629 92.7487 216.703 92.5224 216.764 92.3043C216.838 92.0409 216.896 91.8022 216.945 91.5389L216.965 91.4483C217.006 91.2179 217.043 90.971 217.068 90.7159L217.08 90.6047C217.105 90.3249 217.117 90.0657 217.117 89.8147H217.732C217.732 90.0821 217.72 90.362 217.691 90.6624L217.679 90.7817C217.65 91.0533 217.613 91.3167 217.568 91.5636L217.556 91.6212C217.494 91.938 217.433 92.1973 217.363 92.4442C217.289 92.7075 217.207 92.9503 217.101 93.2343L217.043 93.3906C216.949 93.6334 216.846 93.8721 216.736 94.1025C216.707 94.1643 216.674 94.2301 216.641 94.2918L216.592 94.3865C216.506 94.5511 216.42 94.7198 216.33 94.8803C216.285 94.9585 216.236 95.0367 216.19 95.1107L216.145 95.1848C216.051 95.3371 215.957 95.4893 215.854 95.6375C215.785 95.7403 215.711 95.8432 215.637 95.9461C215.534 96.0901 215.428 96.23 215.317 96.374C215.239 96.4769 215.157 96.5757 215.071 96.6744C214.944 96.8267 214.813 96.9748 214.678 97.123L214.624 97.1806C214.579 97.23 214.538 97.2752 214.493 97.3246C214.292 97.5386 214.083 97.7485 213.862 97.9501C213.628 98.1682 213.39 98.3698 213.152 98.5674C213.103 98.6085 213.05 98.6497 213.001 98.6908L212.931 98.7484C212.755 98.8883 212.578 99.0241 212.394 99.1558C212.308 99.2175 212.222 99.2793 212.136 99.341C211.935 99.4809 211.734 99.6167 211.525 99.7484L211.32 99.8801C211.041 100.053 210.754 100.222 210.463 100.382L210.266 100.485C210.024 100.613 209.778 100.74 209.528 100.864L209.307 100.971C208.999 101.115 208.687 101.254 208.368 101.386L161.275 120.682C160.496 120.998 159.68 121.282 158.848 121.517C157.929 121.776 156.974 121.986 156.007 122.138C155.154 122.274 154.28 122.365 153.411 122.414C152.936 122.439 152.456 122.455 151.976 122.455L151.96 122.447Z",
    fill: "url(#paint16_linear_35_83550)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.96 22.4639C154.986 22.4639 158.007 23.0071 160.722 24.0893L205.654 42.0597C211.07 44.2283 214.415 48.2364 214.415 52.5695V88.5144C214.415 92.8517 211.074 96.8556 205.654 99.0243L160.722 116.995C158.012 118.081 154.986 118.62 151.96 118.62C148.934 118.62 145.912 118.077 143.198 116.995L98.2663 99.0243C92.8502 96.8556 89.5046 92.8476 89.5046 88.5144V52.5695C89.5046 48.2323 92.8461 44.2283 98.2663 42.0597L143.198 24.0893C145.908 23.0029 148.934 22.4639 151.96 22.4639Z",
    fill: "#2D3770"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M217.375 70.4041C217.375 70.4412 217.367 70.4823 217.363 70.5194C217.339 70.7745 217.302 71.0255 217.257 71.2765C217.252 71.3094 217.244 71.3383 217.236 71.3712C217.187 71.6263 217.125 71.8814 217.056 72.1324C217.056 72.1407 217.052 72.153 217.048 72.1613C216.978 72.4082 216.892 72.6551 216.801 72.8978C216.781 72.9472 216.765 72.9966 216.744 73.046C216.654 73.2805 216.555 73.511 216.445 73.7373C216.4 73.8279 216.351 73.9184 216.305 74.013C216.223 74.1735 216.141 74.334 216.047 74.4945C215.99 74.5932 215.928 74.692 215.867 74.7908C215.777 74.9389 215.682 75.0871 215.584 75.2311C215.514 75.334 215.444 75.4327 215.371 75.5315C215.268 75.6714 215.166 75.8113 215.059 75.9471C214.981 76.0459 214.903 76.1446 214.821 76.2393C214.698 76.3874 214.567 76.5355 214.436 76.6796C214.374 76.7454 214.317 76.8113 214.255 76.8771C214.059 77.087 213.854 77.2886 213.64 77.4902C213.636 77.4902 213.632 77.4985 213.628 77.5026C213.411 77.7042 213.177 77.9017 212.943 78.0952C212.87 78.1528 212.796 78.2104 212.722 78.2721C212.55 78.4079 212.373 78.5437 212.193 78.6754C212.107 78.7371 212.025 78.7988 211.939 78.8564C211.742 78.9922 211.541 79.128 211.336 79.2597C211.266 79.305 211.201 79.3461 211.135 79.3914C210.861 79.5601 210.582 79.7247 210.291 79.8852C210.229 79.9181 210.164 79.951 210.098 79.9881C209.86 80.1156 209.618 80.2391 209.372 80.3584C209.298 80.3955 209.229 80.4284 209.155 80.4613C208.852 80.6012 208.548 80.7411 208.233 80.8687L161.14 100.164C160.365 100.481 159.566 100.757 158.746 100.987C157.831 101.246 156.843 101.481 155.896 101.633L155.929 111.291C156.88 111.143 157.831 110.933 158.746 110.678C159.566 110.448 160.365 110.172 161.14 109.855L208.233 90.5596C208.548 90.4321 208.856 90.2921 209.155 90.1522C209.229 90.1193 209.303 90.0823 209.372 90.0494C209.442 90.0164 209.516 89.9835 209.581 89.9506C209.758 89.8642 209.926 89.7695 210.098 89.679C210.164 89.6461 210.229 89.6132 210.291 89.5761C210.578 89.4156 210.861 89.251 211.135 89.0823C211.205 89.0412 211.271 88.9959 211.336 88.9506C211.541 88.819 211.742 88.6873 211.939 88.5474C212.025 88.4856 212.111 88.428 212.193 88.3663C212.373 88.2346 212.55 88.0988 212.722 87.963C212.796 87.9054 212.87 87.8478 212.943 87.7902C213.181 87.5968 213.411 87.3993 213.628 87.1935L213.636 87.1853C213.854 86.9836 214.055 86.7779 214.255 86.5721C214.317 86.5063 214.378 86.4405 214.436 86.3746C214.514 86.2882 214.6 86.2018 214.678 86.1154C214.727 86.0578 214.772 85.996 214.821 85.9384C214.903 85.8397 214.981 85.745 215.059 85.6463C215.166 85.5105 215.272 85.3705 215.371 85.2306C215.444 85.1319 215.514 85.0331 215.584 84.9302C215.682 84.7862 215.777 84.6381 215.867 84.4899C215.928 84.3912 215.99 84.2924 216.047 84.1937C216.137 84.0332 216.223 83.8727 216.305 83.7122C216.351 83.6217 216.404 83.5311 216.445 83.4365C216.453 83.4159 216.465 83.3953 216.478 83.3748C216.576 83.1649 216.662 82.955 216.744 82.7452C216.765 82.6958 216.781 82.6464 216.801 82.597C216.892 82.3542 216.978 82.1073 217.048 81.8563C217.048 81.8481 217.052 81.8357 217.056 81.8275C217.101 81.6711 217.142 81.5106 217.179 81.3502C217.199 81.2555 217.22 81.1609 217.236 81.0662C217.24 81.0333 217.248 81.0045 217.257 80.9716C217.302 80.7206 217.339 80.4695 217.363 80.2144C217.363 80.1774 217.371 80.1362 217.375 80.0992C217.392 79.9058 217.404 79.7165 217.412 79.519C217.412 79.4367 217.412 79.3585 217.412 79.2762V69.5894C217.412 69.8651 217.4 70.1367 217.375 70.4083V70.4041Z",
    fill: "url(#paint17_linear_35_83550)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M153.374 101.872C152.903 101.897 152.431 101.909 151.956 101.909C151.587 101.909 151.218 101.901 150.849 101.884C149.963 101.847 149.086 101.765 148.213 101.633C147.192 101.481 146.183 101.267 145.199 100.991C144.371 100.757 143.559 100.481 142.776 100.16L95.6833 80.8647C90.0048 78.5356 86.5034 74.2354 86.5034 69.5771V79.264C86.5034 83.9181 90.0048 88.2224 95.6833 90.5515L142.776 109.847C143.563 110.168 144.371 110.448 145.199 110.678C146.183 110.954 147.192 111.168 148.213 111.32C149.082 111.448 149.963 111.53 150.849 111.571C151.218 111.588 151.587 111.596 151.956 111.596C152.427 111.596 152.903 111.584 153.374 111.559C154.235 111.514 155.092 111.423 155.941 111.287V101.6C155.092 101.732 154.235 101.823 153.374 101.872Z",
    fill: "url(#paint18_linear_35_83550)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M151.96 0C155.129 0 158.298 0.580221 161.14 1.74478L208.232 21.0402C213.911 23.3693 217.412 27.6696 217.412 32.3278V70.9228C217.412 75.5769 213.911 79.8812 208.232 82.2104L161.14 101.506C158.298 102.67 155.129 103.251 151.96 103.251C148.79 103.251 145.621 102.67 142.78 101.506L95.6872 82.2104C90.0087 79.8812 86.5073 75.581 86.5073 70.9228V32.3278C86.5073 27.6737 90.0087 23.3693 95.6872 21.0402L142.776 1.74478C145.617 0.580221 148.786 0 151.956 0H151.96Z",
    fill: "url(#paint19_linear_35_83550)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M151.96 103.555C151.587 103.555 151.214 103.547 150.841 103.53C149.947 103.493 149.049 103.407 148.171 103.279C147.134 103.127 146.105 102.909 145.121 102.629C144.276 102.39 143.452 102.106 142.665 101.785L95.5725 82.49C89.7915 80.1197 86.2 75.6837 86.2 70.9185H86.815C86.815 75.4285 90.2589 79.6465 95.8062 81.918L142.899 101.213C143.666 101.526 144.469 101.802 145.289 102.032C146.249 102.304 147.253 102.514 148.266 102.666C149.119 102.794 149.996 102.876 150.869 102.913C151.697 102.95 152.534 102.946 153.362 102.896C154.211 102.851 155.064 102.761 155.896 102.629C156.839 102.481 157.77 102.275 158.663 102.024C159.475 101.794 160.271 101.522 161.025 101.213L208.118 81.918C208.429 81.7904 208.728 81.6546 209.028 81.5147L209.245 81.4118C209.487 81.2925 209.725 81.1731 209.963 81.0456L210.151 80.9468C210.434 80.7905 210.713 80.63 210.979 80.4612L211.18 80.3337C211.381 80.2061 211.578 80.0744 211.771 79.9386C211.857 79.881 211.939 79.8193 212.021 79.7576C212.197 79.63 212.369 79.4983 212.537 79.3625L212.603 79.309C212.652 79.2679 212.705 79.2308 212.755 79.1897C212.984 79.0004 213.21 78.807 213.427 78.6095C213.648 78.4037 213.849 78.2021 214.042 78.0005C214.083 77.9552 214.124 77.914 214.165 77.8688L214.222 77.807C214.354 77.6671 214.477 77.5231 214.6 77.3791C214.678 77.2844 214.755 77.1898 214.833 77.091C214.94 76.9593 215.038 76.8235 215.141 76.6836C215.211 76.5849 215.28 76.4902 215.346 76.3915C215.44 76.2516 215.53 76.1075 215.621 75.9635L215.666 75.8935C215.711 75.8195 215.756 75.7495 215.797 75.6754C215.887 75.5191 215.965 75.3627 216.047 75.2063L216.1 75.1076C216.129 75.0541 216.158 74.9965 216.186 74.943C216.289 74.7249 216.387 74.4985 216.477 74.2722L216.527 74.1447C216.633 73.8566 216.711 73.6262 216.773 73.4122C216.846 73.1488 216.904 72.9101 216.953 72.6468L216.974 72.5562C217.015 72.3258 217.051 72.0789 217.076 71.8238L217.088 71.7127C217.113 71.4328 217.125 71.1736 217.125 70.9226H217.74C217.74 71.1901 217.728 71.4699 217.699 71.7703L217.687 71.8896C217.658 72.1612 217.621 72.4246 217.576 72.6715L217.564 72.7291C217.502 73.0459 217.441 73.3052 217.371 73.5521C217.297 73.8155 217.215 74.0582 217.109 74.3422L217.051 74.4985C216.957 74.7413 216.855 74.98 216.744 75.2105C216.715 75.2722 216.682 75.338 216.65 75.3997L216.6 75.4944C216.514 75.659 216.428 75.8277 216.338 75.9882C216.293 76.0664 216.244 76.1446 216.195 76.2269L216.154 76.2968C216.059 76.4491 215.965 76.5972 215.862 76.7495C215.793 76.8523 215.719 76.9511 215.649 77.054C215.543 77.2021 215.436 77.342 215.325 77.482C215.247 77.5848 215.165 77.6836 215.079 77.7824C214.952 77.9346 214.821 78.0828 214.686 78.2309L214.632 78.2926C214.587 78.342 214.546 78.3873 214.501 78.4366C214.28 78.6671 214.075 78.8728 213.87 79.0621C213.653 79.2638 213.423 79.4654 213.161 79.6794C213.107 79.7247 213.054 79.7658 213.001 79.807L212.935 79.8563C212.759 79.9962 212.582 80.132 212.398 80.2637C212.312 80.3255 212.226 80.3872 212.14 80.4489C211.939 80.5888 211.738 80.7246 211.529 80.8563L211.324 80.988C211.045 81.1608 210.758 81.3295 210.467 81.49L210.27 81.5929C210.028 81.7204 209.782 81.848 209.532 81.9715L209.311 82.0785C209.003 82.2225 208.696 82.3624 208.372 82.4941L161.279 101.79C160.5 102.106 159.684 102.39 158.852 102.625C157.934 102.884 156.978 103.094 156.011 103.246C155.158 103.382 154.285 103.473 153.415 103.522C152.94 103.547 152.456 103.563 151.98 103.563L151.96 103.555Z",
    fill: "url(#paint20_linear_35_83550)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M144.99 34.0234V36.1509L144.609 36.3073V34.1798L144.99 34.0234Z",
    fill: "#93D1C2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M162.489 35.4799V37.6074L144.851 30.3814V28.2539L162.489 35.4799Z",
    fill: "#7DBDAE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M144.609 34.1797V36.3072L127.352 43.3768V41.2493L144.609 34.1797Z",
    fill: "#93D1C2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M151.96 25.9289C152.887 25.9289 153.813 26.0976 154.641 26.4351L169.602 32.5665V58.5571L162.489 61.4706V35.4758L144.846 28.2457L149.279 26.431C150.107 26.0935 151.033 25.9248 151.96 25.9248V25.9289Z",
    fill: "url(#paint21_linear_35_83550)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M169.602 58.561V60.6885L162.489 63.602V61.4745L169.602 58.561Z",
    fill: "#93D1C2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_35_83550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 62,
    width: 3,
    height: 6
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M122.92 65.4294V67.5569C121.263 66.8779 120.234 65.6187 120.234 64.2608V62.1333C120.234 63.4913 121.263 64.7505 122.92 65.4294Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_35_83550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.92 65.4294V67.5569C121.263 66.8779 120.234 65.6187 120.234 64.2608V62.1333C120.234 63.4913 121.263 64.7505 122.92 65.4294Z",
    fill: "#7DBDAE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_35_83550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 62,
    width: 3,
    height: 6
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M183.682 62.1372V64.2647C183.682 65.6185 182.657 66.8819 181.004 67.5608V65.4334C182.657 64.7544 183.682 63.4911 183.682 62.1372Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_35_83550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.678 62.207V64.3345C183.674 64.5156 183.649 64.6925 183.612 64.8654V62.7379C183.653 62.565 183.674 62.384 183.678 62.207Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.612 62.7378V64.8653C183.567 65.0669 183.497 65.2644 183.407 65.4578V63.3304C183.497 63.1369 183.567 62.9394 183.612 62.7378Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.407 63.3306V65.4581C183.276 65.742 183.1 66.0095 182.878 66.2605V64.133C183.095 63.882 183.276 63.6104 183.407 63.3306Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.878 64.1328V66.2603C182.497 66.6965 181.993 67.0833 181.386 67.3837V65.2562C181.993 64.9558 182.497 64.569 182.878 64.1328Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.39 65.2563V67.3838C181.267 67.4456 181.136 67.5032 181.004 67.5608V65.4333C181.136 65.3798 181.267 65.3181 181.39 65.2563Z",
    fill: "#93D1C2"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M155.515 64.3306V66.458L151.964 67.9189V65.7914L155.515 64.3306Z",
    fill: "#93D1C2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M151.964 36.8789L155.515 38.3356V64.3304L151.964 65.7912L148.405 64.3304V38.3356L148.532 38.2821L151.964 36.8789Z",
    fill: "url(#paint22_linear_35_83550)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M151.964 65.7914V67.9189L148.405 66.458V64.3306L151.964 65.7914Z",
    fill: "#7DBDAE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M137.876 31.1099L144.99 34.0233L144.609 34.1797L127.352 41.2493V67.2482L122.92 65.4334C121.263 64.7545 120.234 63.4953 120.234 62.1373V40.5333C120.234 39.1795 121.263 37.9161 122.92 37.2372L137.876 31.1099Z",
    fill: "url(#paint23_linear_35_83550)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M127.352 67.248V69.3755L122.92 67.5567V65.4292L127.352 67.248Z",
    fill: "#7DBDAE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M166.043 71.5606V73.6881L158.926 70.7705V68.6431L166.043 71.5606Z",
    fill: "#7DBDAE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M181 65.4331V67.5606L166.043 73.6879V71.5604L181 65.4331Z",
    fill: "#93D1C2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M176.568 35.4224L181 37.2371C182.657 37.9161 183.682 39.1794 183.682 40.5332V62.1372C183.682 63.4911 182.657 64.7544 181.004 65.4334L166.048 71.5648L158.93 68.6472L159.315 68.4909L176.572 61.4212V35.4224H176.568Z",
    fill: "url(#paint24_linear_35_83550)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M149.283 76.2351V78.3626L134.322 72.2271V70.0996L149.283 76.2351Z",
    fill: "#7DBDAE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M159.073 74.4204V76.5479L154.641 78.3626V76.2351L159.073 74.4204Z",
    fill: "#93D1C2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M141.435 41.1914V67.1903L159.078 74.4204L154.645 76.2351C153.834 76.5643 152.907 76.7413 151.964 76.7413C151.021 76.7413 150.09 76.5643 149.283 76.231L134.322 70.0996V44.1049L141.435 41.1914Z",
    fill: "url(#paint25_linear_35_83550)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_35_83550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 149,
    y: 76,
    width: 6,
    height: 3
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M154.641 76.2356V78.363C153.83 78.6922 152.903 78.8692 151.96 78.8692C151.017 78.8692 150.086 78.6922 149.279 78.3589V76.2314C150.086 76.5648 151.017 76.7417 151.96 76.7417C152.903 76.7417 153.83 76.5648 154.641 76.2356Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_35_83550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.641 76.2354V78.3628C154.42 78.4534 154.19 78.5315 153.952 78.5974V76.4699C154.19 76.4041 154.42 76.3259 154.641 76.2354Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.957 76.4702V78.5977C153.686 78.6718 153.411 78.7335 153.128 78.7788V76.6513C153.411 76.606 153.69 76.5443 153.957 76.4702Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.128 76.6514V78.7788C152.882 78.8159 152.628 78.8447 152.374 78.857V76.7296C152.628 76.7172 152.878 76.6884 153.128 76.6514Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.374 76.7334V78.8609C152.239 78.8691 152.099 78.8732 151.964 78.8732C151.857 78.8732 151.747 78.8732 151.64 78.865V76.7375C151.747 76.7416 151.853 76.7457 151.964 76.7457C152.103 76.7457 152.239 76.7457 152.374 76.7334Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.64 76.7376V78.8651C151.382 78.8528 151.123 78.8281 150.869 78.7911V76.6636C151.123 76.7006 151.382 76.7253 151.64 76.7376Z",
    fill: "#93D1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.988 76.4742C149.746 76.4043 149.508 76.3261 149.282 76.2314V78.3589C149.508 78.4536 149.746 78.5318 149.988 78.6017C150.275 78.6799 150.566 78.7457 150.869 78.7869V76.6594C150.57 76.6141 150.275 76.5524 149.988 76.4701V76.4742Z",
    fill: "url(#paint26_linear_35_83550)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_35_83550",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.304 132.657) scale(91.6391 91.9754)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#093640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#315A62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#96B6B8",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF5F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_83550",
    x1: 207.855,
    y1: 56.4751,
    x2: 332.085,
    y2: 56.4751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35_83550",
    x1: 206.392,
    y1: 110.637,
    x2: 365.115,
    y2: 110.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35_83550",
    x1: -45,
    y1: 88.5188,
    x2: 331.688,
    y2: 88.5188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_35_83550",
    x1: -45,
    y1: 67.9192,
    x2: 331.688,
    y2: 67.9192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_35_83550",
    x1: -45,
    y1: 65.5403,
    x2: 86.9175,
    y2: 65.5403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_35_83550",
    x1: -45,
    y1: 62,
    x2: 87,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_35_83550",
    x1: -45,
    y1: 63.9959,
    x2: 87,
    y2: 63.9959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_35_83550",
    x1: -45,
    y1: 105.818,
    x2: 86.4747,
    y2: 105.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_35_83550",
    x1: 155.879,
    y1: 128.217,
    x2: 217.416,
    y2: 128.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#093640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#08313B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_35_83550",
    x1: 86.4993,
    y1: 128.373,
    x2: 155.941,
    y2: 128.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#093640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0B3B46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#104854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#23788C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#093640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_35_83550",
    x1: 151.96,
    y1: 38.2124,
    x2: 151.96,
    y2: 138.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185361",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_35_83550",
    x1: 86.1918,
    y1: 125.019,
    x2: 217.724,
    y2: 125.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#093640",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0C3D48",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#16515F",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1E6272",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#257082",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2A7B8E",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2E8397",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#30879C",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#31899E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#30879B",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2D8194",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#287689",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#216879",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#185664",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0D404B",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093640",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_35_83550",
    x1: 155.871,
    y1: 109.328,
    x2: 217.416,
    y2: 109.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5468D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#4B5FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#495DC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_35_83550",
    x1: 86.4993,
    y1: 109.481,
    x2: 155.941,
    y2: 109.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#576BD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6C7EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B5C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#586CDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_35_83550",
    x1: 151.96,
    y1: 19.3201,
    x2: 151.96,
    y2: 119.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#788AF0",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C70E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_35_83550",
    x1: 86.1918,
    y1: 106.131,
    x2: 217.724,
    y2: 106.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C70E6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6175E7",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7284EC",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#8292F0",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#909EF4",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#9BA9F7",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#A4B1FA",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ACB7FC",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B1BCFD",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B4BFFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#B5C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B3BEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#AFBAFD",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#A8B4FB",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#9EABF8",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#91A0F5",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#8191F0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#6F81EB",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C70E6",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_35_83550",
    x1: 155.896,
    y1: 90.4362,
    x2: 217.416,
    y2: 90.4362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98E0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8DDBC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79D1BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_35_83550",
    x1: 86.4993,
    y1: 90.5927,
    x2: 155.941,
    y2: 90.5927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82D1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#93DFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A0EBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C0F0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#98E0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_35_83550",
    x1: 151.96,
    y1: 0.43208,
    x2: 151.96,
    y2: 101.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBF0E3",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#AFECDD",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A9EBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_35_83550",
    x1: 86.1918,
    y1: 87.2387,
    x2: 217.724,
    y2: 87.2387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82D1C0",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#92D7C8",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A0DDCF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ACE2D6",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6E6DB",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#BFEAE0",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C5ECE3",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#CAEEE6",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CDEFE7",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#CEF0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CDEFE7",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CAEEE6",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5EDE4",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#BFEBE1",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#B7E9DD",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ACE6D8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A1E2D3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98E0CF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_35_83550",
    x1: 150.156,
    y1: 22.1307,
    x2: 177.88,
    y2: 65.2423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0FEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E3FBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFAF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_35_83550",
    x1: 138.217,
    y1: 29.8051,
    x2: 165.941,
    y2: 72.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4FEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E6FBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFAF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_35_83550",
    x1: 125.79,
    y1: 37.8009,
    x2: 153.514,
    y2: 80.9125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4FEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E6FBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFAF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_35_83550",
    x1: 150.644,
    y1: 21.818,
    x2: 178.368,
    y2: 64.9296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4FEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E6FBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFAF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_35_83550",
    x1: 126.282,
    y1: 37.4838,
    x2: 154.006,
    y2: 80.5954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4FEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E6FBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFAF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_35_83550",
    x1: 149.282,
    y1: 77.5112,
    x2: 150.869,
    y2: 77.5112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DBDAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93D1C2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_83550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 410,
    height: 186,
    fill: "white",
    transform: "translate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleImg);
export default __webpack_public_path__ + "static/media/role_img.a5497102511abfeb7daa8567caf42a88.svg";
export { ForwardRef as ReactComponent };